import { useFeatureFlag } from '@mews/framework';
import { FeatureFlag } from '@mews-commander/enums';
import { GuestSmartTips } from '../../../../../accounts/modules/guestSmartTips/components/guestSmartTips';

interface SmartTipsCustomerListProps {
    id: string;
    chainId: string;
    enterpriseIds: string;
}

export const SmartTipsCustomerList = ({ id }: SmartTipsCustomerListProps) => {
    const smartTipsReservationGuestsEnabled = useFeatureFlag(FeatureFlag.smartTipsReservationGuestsEnabled);
    const gxGuestAiSmartTipsTimelinePage = useFeatureFlag(FeatureFlag.gxGuestAiSmartTipsTimelinePage);

    return (
        <GuestSmartTips
            guestId={id}
            hasSmartTipsAccess={smartTipsReservationGuestsEnabled}
            useAssistantApi={!gxGuestAiSmartTipsTimelinePage}
        />
    );
};
